document.addEventListener('DOMContentLoaded', function () {
  const grid = document.getElementById('devices-grid');
  const viewMoreBtn = document.getElementById('view-more-btn');

  if (!grid || !viewMoreBtn) return;

  const mask = grid.querySelector('.gradient-mask');

  viewMoreBtn.addEventListener('click', function () {
    const collapsed = grid.classList.toggle('masked');

    if (mask) mask.classList.toggle('hidden', !collapsed);

    if (collapsed) {
      viewMoreBtn.textContent = 'View all';
      viewMoreBtn.classList.add('accent');
      grid.scrollIntoView({ behavior: 'smooth' });
    } else {
      viewMoreBtn.textContent = 'View less';
      viewMoreBtn.classList.remove('accent');
    }
  });
});
